<div #parent class="header-image-carousel-price-container" [style.color]="textColor">
  <div class="header-image-carousel-price" [class.sale]="salePrice | exists">
    {{ originalPrice }}
  </div>
  <div *ngIf="salePrice | exists" class="header-image-carousel-sale-price" [style.color]="textColor">
    {{ salePrice }}
  </div>
</div>
